/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Why should I avoid declaring styled components in the render method?"
    }), "\n", _jsx(_components.p, {
      children: "By declaring a styled component inside the render method of a react component, you are dynamically creating a new component on every render.\nThis means that React will have to discard and re-calculate that part of the DOM subtree on each subsequent render, instead of just calculating the difference of what changed between them. This leads to performance bottlenecks and unpredictable behavior."
    }), "\n", _jsx(_components.p, {
      children: "🚫"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Header = () => {\n  const Title = styled.h1`\n    font-size: 10px;\n  `\n\n  return (\n    <div>\n      <Title />\n    </div>\n  )\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "✅"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Title = styled.h1`\n  font-size: 10px;\n`\n\nconst Header = () => {\n  return (\n    <div>\n      <Title />\n    </div>\n  )\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
